/* import __COLOCATED_TEMPLATE__ from './striped-progress-bar.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import clsx from 'clsx';

const SECONDARY_COLOR_OPACITY = 0.4;

const _hexToRgbaSecondaryStripe = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);
  return `rgba(${r}, ${g}, ${b}, ${SECONDARY_COLOR_OPACITY})`;
}

const _normalizeHex = (hex) => {
  return hex.substr(0, 1) !== '#' ? `#${hex}` : hex;
}

const CLASS_NAME = 'SH-c-striped-progress-bar';

class StripedProgressBarComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get hasNoLimit() {
    return this.args.limit == 0;
  }

  get percent() {
    const { limit } = this.args;
    if (this.hasNoLimit) return 100;

    return Math.min((this.args.value / limit) * 100, 100);
  }

  get progressBarStyles() {
    const hex = _normalizeHex(this.args.hex);
    const rgba = _hexToRgbaSecondaryStripe(hex);
    const { percent } = this;
    const borderRadius = percent >= 98 ? '6px' : '6px 0 0 6px';
    const borderRight = percent <= 2 || percent >= 98 ? 'none' : '2px solid #FFFFFF';

    // make UI more clear when progress has filled
    const lowerThreshold = percent > 0 ? Math.max(2, percent) : percent;
    const uiPercent = percent > 99 && percent < 100 ? 99 : lowerThreshold;

    return htmlSafe(`
      --progress-bar-background:
        repeating-linear-gradient(
          -45deg,
          ${hex},
          ${hex} 5px,
          ${rgba} 5px,
          ${rgba} 8px
        );
      --progress-bar-percent: ${uiPercent}%;
      --progress-bar-border-radius: ${borderRadius};
      --progress-bar-border-right: ${borderRight};
    `);
  }
}

export default StripedProgressBarComponent;
